import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgKebabHorizontal = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.26316 12.0002C7.26316 13.4536 6.08496 14.6318 4.63158 14.6318C3.1782 14.6318 2 13.4536 2 12.0002C2 10.5469 3.1782 9.36865 4.63158 9.36865C6.08496 9.36865 7.26316 10.5469 7.26316 12.0002ZM14.6316 12.0002C14.6316 13.4536 13.4534 14.6318 12 14.6318C10.5466 14.6318 9.36842 13.4536 9.36842 12.0002C9.36842 10.5469 10.5466 9.36865 12 9.36865C13.4534 9.36865 14.6316 10.5469 14.6316 12.0002ZM19.3684 14.6318C20.8218 14.6318 22 13.4536 22 12.0002C22 10.5469 20.8218 9.36865 19.3684 9.36865C17.915 9.36865 16.7368 10.5469 16.7368 12.0002C16.7368 13.4536 17.915 14.6318 19.3684 14.6318Z", fill: props.fill }));
});
export default SvgKebabHorizontal;
